<template>
  <div>
    <div class="abs-center-container">
      <div class="abs-center">
        <div class="card medium-margin-v-s">
          <h2 class="margin-t-z margin-b-s">Reset Password</h2>
          <div class="row">
            <div class="large-12 column">
              <div v-bind:class="['field-group' + (!error.password ? '': ' field-error')]">
                <label>Password</label>
                <input type="password" :class="['field-text', {disabled:loading}]"
                  v-model="password" :disabled="loading" />
                <label class="field-error-message">{{error.password}}</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="large-12 column">
              <div v-bind:class="['field-group' + (!error.rpassword ? '': ' field-error')]">
                <label>Retype Password</label>
                <input type="password" :class="['field-text', {disabled:loading}]"
                  v-model="rpassword" :disabled="loading" />
                <label class="field-error-message">{{error.rpassword}}</label>
              </div>
            </div>
          </div>

          <span class="api-error" v-show="apiError">{{apiError}}</span>

          <div class="row">
            <div class="large-12 column">
              <br/>
              <button v-bind:class="{'op-btn btn-success btn-lg btn-continue btn-block':true, disabled:loading }" @click="submit">
                <span v-show="loading">
                  <i class="fa fa-spinner fa-spin"></i>
                  Loading...
                </span>
                <span v-show="!loading">Submit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, hide:!showSuccess }">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="success">
            <span>Password changed successfully!</span>
            <button class="op-btn btn-success btn-lg btn-continue btn-block" @click="close">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search-edit',
  data () {
    return {
      token: '',
      password: '',
      rpassword: '',
      loading: false,
      error: {
        password: '',
        rpassword: ''
      },
      apiError: '',
      showSuccess: false
    }
  },
  computed: {
  },
  methods: {
    submit () {
      let self = this

      if (self.loading) { return }

      self.apiError = ''
      self.error = {
        password: '',
        rpassword: ''
      }
      let hasError = false
      for (let field in self.error) {
        if (!self[field]) {
          self.error[field] = 'This is required.'
          hasError = true
        }
      }

      if (self.password && self.rpassword && self.password !== self.rpassword) {
        self.error.password = 'Password does not match'
        self.error.rpassword = 'Password does not match'
        hasError = true
      }

      if (self.password && self.password.length < 8) {
        self.error.password = 'Must be at least 8 characters.'
        hasError = true
      }
      if (self.rpassword && self.rpassword.length < 8) {
        self.error.rpassword = 'Must be at least 8 characters.'
        hasError = true
      }

      if (hasError) { return }
      self.loading = true
      self.$sdk.post(self, '/auth/password', {
        token: self.token,
        password: self.password,
        d2d: 1
      }, res => {
        self.loading = false
        if (res.error) {
          self.apiError = res.error.message
          return
        }
        self.showSuccess = true
      }, '1.1')
    },
    close () {
      document.location.href = '/';
    }
  },
  watch: {
  },
  mounted () {
    document.body.classList.add('widget-full')
    this.token = this.$route.query.token
  }
}
</script>

<style lang="scss" scoped>
.abs-center-container {
  position: fixed;
  display: table;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  & .abs-center{
    display: table-cell;
    vertical-align: middle;
  }
  &.show-on-load{
    position: relative;
    display: block;
    text-align: left;

    .abs-center{ display: block; }
    .card{
      padding: 30px;
      border: none;
      box-shadow: none;
    }
  }
}

.card {
  max-width: 500px;
  margin: 0 auto;
  border-radius: 3px;

  & h2 {
    font-size: 22px;
    margin-bottom: 20px;
    text-align: center;
  }
}

.api-error{
  border: 1px solid #EB5837;
  background: #fef3f0;
  color: #EB5837;
  padding: 5px;
  font-size: 13px;
  font-style: italic;
  display: block;
}

.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.success{
  background-color: #fff;
  max-width: 500px;
  padding: 40px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;

  span{
    font-size: 21px;
    display: block;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5d7919fa